<template>
  <div class="form-group">
    <app-checkbox
      :id="id"
      :value="value"
      :disabled="disabled || lockedOnMount"
      :label-class="['h6', { 'font-weight-normal': fontNormal }]"
      @input="$emit('input', $event)"
    >
      {{ label }}<span v-if="required" class="text-danger ml-1">*</span><slot name="after-label" />
    </app-checkbox>
    <small v-if="hint" class="form-text text-muted">{{ hint }}</small>
    <div v-if="error" class="text-danger small mt-1">{{ error }}</div>
  </div>
</template>

<script>
import AppCheckbox from '@/components/AppCheckbox'

export default {
  name: 'FCheckbox',
  components: { AppCheckbox },
  props: {
    value: { type: Boolean, default: false },
    label: String,
    id: { type: String, required: true },
    disabled: Boolean,
    hint: String,
    lockIfTrue: { type: Boolean, default: false },
    fontNormal: { type: Boolean, default: false },
    required: Boolean,
    error: { type: String, default: null }
  },
  data() {
    return {
      lockedOnMount: false
    }
  },
  created() {
    if (this.lockIfTrue && this.value === true) {
      this.lockedOnMount = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FCheckbox.vue